<!--<template>
  <div class="formula" @mouseleave="closeDialog">
    <div class="gs" id="box_div_editor_client" v-show="visible">
      <i class="carts"/>
      <div class="gs_tit">
        <ul>
          <li id="twoo1" :class="{'hover':showStatus === 0}">
            <input
              type="button"
              value="常用公式"
              class="gs_an"
              style=" background:none; border:0px; cursor:pointer"
              @click="setTab(0)"
            >
          </li>
          <li id="twoo2" :class="{'hover':showStatus === 1}">
            <input
              type="button"
              value="数学符号"
              style=" background:none; border:0px; cursor:pointer"
              @click="setTab(1)"
            >
          </li>
          <li id="twoo3" :class="{'hover':showStatus === 2}">
            <input
              type="button"
              value="希腊字母"
              style=" background:none; border:0px; cursor:pointer"
              @click="setTab(2)"
            >
          </li>
        </ul>
      </div>
      <div id="div_FormulaBlock" class="menuDiv">
        <div id="con_twoo_1" v-if="showStatus === 0">
          <div class="gs_nr">
            <ul>
              <li class="fc1">
                <a
                  @click="insertWrite('\\frac', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc3">
                <a
                  @click="insertWrite('x^', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc4">
                <a
                  @click="insertWrite('x_', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc5">
                <a
                  @click="insertWrite('x_{}^{}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc6">
                <a
                  @click="insertWrite('\\bar{x}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc7">
                <a
                  @click="insertWrite('\\sqrt', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc8">
                <a
                  @click="insertWrite('\\nthroot3{}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc9">
                <a
                  @click="insertWrite('\\nthroot', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc10">
                <a
                  @click="insertWrite('\\sum^{}_{n=}', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc11">
                <a
                  @click="insertWrite('\\sum', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc12">
                <a
                  @click="insertWrite('\\log_{}\\left(\\right)', true)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fc13">
                <a
                  @click="insertWrite('\\ln', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
            </ul>
          </div>
        </div>
        <div id="con_twoo_2" v-else-if="showStatus === 1">
          <div class="gs_nr">
            <ul>
              <li class="fa1">
                <a
                  @click="insertWrite('+', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa2">
                <a
                  @click="insertWrite('-', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa3">
                <a
                  @click="insertWrite('\\pm', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa4">
                <a
                  @click="insertWrite('\\times', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa5">
                <a
                  @click="insertWrite('\\ast', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa6">
                <a
                  @click="insertWrite('\\div', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa7">
                <a
                  @click="insertWrite('/', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa8">
                <a
                  @click="insertWrite('\\infty', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa9">
                <a
                  @click="insertWrite('\\partial', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa10">
                <a
                  @click="insertWrite('\\bigtriangleup', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa11">
                <a
                  @click="insertWrite('=', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa12">
                <a
                  @click="insertWrite('\\ne', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa13">
                <a
                  @click="insertWrite('\\approx', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa14">
                <a
                  @click="insertWrite('>', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa15">
                <a
                  @click="insertWrite('<', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa16">
                <a
                  @click="insertWrite('\\ge', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fa17">
                <a
                  @click="insertWrite('\\le', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
            </ul>
          </div>
        </div>
        <div id="con_twoo_3" v-else-if="showStatus === 2">
          <div class="gs_nr">
            <ul>
              <li class="fb1">
                <a
                  @click="insertWrite('\\alpha', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb2">
                <a
                  @click="insertWrite('\\beta', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb3">
                <a
                  @click="insertWrite('\\gamma', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb4">
                <a
                  @click="insertWrite('\\delta', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb5">
                <a
                  @click="insertWrite('\\varepsilon', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb6">
                <a
                  @click="insertWrite('\\varphi', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb7">
                <a
                  @click="insertWrite('\\lambda', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb8">
                <a
                  @click="insertWrite('\\mu', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb9">
                <a
                  @click="insertWrite('\\rho', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb10">
                <a
                  @click="insertWrite('\\sigma', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li>
              <li class="fb11">
                <a @click="insertWrite('\\omega', false)" href="javascript:void(0);">&nbsp;</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "formula",
    props: {
      visible: { type: Boolean, default: false },
      toggleFn: { type: Function, default: () => null }
    },
    data() {
      return {
        showStatus: 0
      }
    },
    methods: {
      insertWrite(type, bool) {
        this.$emit('toggleFn', type, bool)
      },
      setTab(type) {
        this.showStatus = type
      },
      closeDialog() {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
<style lang="scss" scoped>
  $bgUrl: '~@/assets/images/formula/';
  .formula {

    .gs {
      width: 328px;
      position: absolute;
      top: 25px;
      left: 62px;
      z-index: 1;

      .carts {
        width: 328px;
        height: 8px;
        background: url($bgUrl + 'jt.png') no-repeat center top;
        display: block
      }
    }

    .gs_tit {
      width: 328px;
      background: url($bgUrl + 'gs_tit.gif') repeat-x;
      height: 29px;
      border-left: 1px solid #c1cee3;
      border-right: 1px solid #c1cee3;

      ul {
        padding-top: 7px;
        overflow: hidden;

        li {
          float: left;
          margin-left: 12px;
          display: inline-block;
          font-size: 14px !important;
          font-weight: bold;
          cursor: pointer;
          line-height: 24px;
          height: 24px;
          width: 93px;
          background: url($bgUrl + 'bg-menu-tab.gif') no-repeat 0 0;
          text-align: center;

          input {
            height: 24px;
            width: 93px;
            display: block;
            outline: none;
          }

          &.hover {
            background: url($bgUrl + 'bg-menu-tab.gif') no-repeat 0 -24px;
          }
        }
      }
    }

    .gs_nr {
      border: 1px solid #c1cee3;
      border-top: none;
      background: #fff;
      overflow: hidden;
      width: 328px;
      padding: 10px 0 10px 10px;
    }

    .gs_nr li {
      margin: 0 6px 6px 0;
      float: left;
      width: 30px;
      height: 30px;
      background: url($bgUrl + 'function.gif') no-repeat;
      cursor: pointer;
      text-indent: -9999px;
    }

    .gs_nr li a {
      display: block;
      height: 30px;
      text-decoration: none;
      width: 30px;
      outline: medium none;
    }

    .gs_nr li.fa1 {
      background-position: 0px 0px;
    }

    .gs_nr li.fa2 {
      background-position: -34px 0px;
    }

    .gs_nr li.fa3 {
      background-position: -68px 0px;
    }

    .gs_nr li.fa4 {
      background-position: -102px 0px;
    }

    .gs_nr li.fa5 {
      background-position: -136px 0px;
    }

    .gs_nr li.fa6 {
      background-position: -170px 0px;
    }

    .gs_nr li.fa7 {
      background-position: -204px 0px;
    }

    .gs_nr li.fa8 {
      background-position: -238px 0px;
    }

    .gs_nr li.fa9 {
      background-position: -272px 0px;
    }

    .gs_nr li.fa10 {
      background-position: 0px -34px;
    }

    .gs_nr li.fa11 {
      background-position: -34px -34px;
    }

    .gs_nr li.fa12 {
      background-position: -68px -34px;
    }

    .gs_nr li.fa13 {
      background-position: -102px -34px;
    }

    .gs_nr li.fa14 {
      background-position: -136px -34px;
    }

    .gs_nr li.fa15 {
      background-position: -170px -34px;
    }

    .gs_nr li.fa16 {
      background-position: -204px -34px;
    }

    .gs_nr li.fa17 {
      background-position: -238px -34px;
    }

    .gs_nr li.fb1 {
      background-position: 0px -68px;
    }

    .gs_nr li.fb2 {
      background-position: -34px -68px;
    }

    .gs_nr li.fb3 {
      background-position: -68px -68px;
    }

    .gs_nr li.fb4 {
      background-position: -102px -68px;
    }

    .gs_nr li.fb5 {
      background-position: -136px -68px;
    }

    .gs_nr li.fb6 {
      background-position: -170px -68px;
    }

    .gs_nr li.fb7 {
      background-position: -204px -68px;
    }

    .gs_nr li.fb8 {
      background-position: -238px -68px;
    }

    .gs_nr li.fb9 {
      background-position: -272px -68px;
    }

    .gs_nr li.fb10 {
      background-position: 0px -102px;
    }

    .gs_nr li.fb11 {
      background-position: -34px -102px;
    }

    .gs_nr li.fc1 {
      background-position: 0px -136px;
    }

    .gs_nr li.fc2 {
      background-position: -34px -136px;
    }

    .gs_nr li.fc3 {
      background-position: -68px -136px;
    }

    .gs_nr li.fc4 {
      background-position: -102px -136px;
    }

    .gs_nr li.fc5 {
      background-position: -136px -136px;
    }

    .gs_nr li.fc6 {
      background-position: -170px -136px;
    }

    .gs_nr li.fc7 {
      background-position: -204px -136px;
    }

    .gs_nr li.fc8 {
      background-position: -238px -136px;
    }

    .gs_nr li.fc9 {
      background-position: -272px -136px;
    }

    .gs_nr li.fc10 {
      background-position: 0px -170px;
    }

    .gs_nr li.fc11 {
      background-position: -34px -170px;
    }

    .gs_nr li.fc12 {
      background-position: -68px -170px;
    }

    .gs_nr li.fc13 {
      background-position: -102px -170px;
    }

    .gs_tit .gs_an {
      background: none;
    }
  }
</style>-->
<template>
  <div class="formula"
       @mouseleave="closeDialog">
    <div class="gs"
         id="box_div_editor_client"
         v-show="visible">
      <i class="carts" />
      <div class="gs_tit">
        <ul>
          <li id="twoo1"
              :class="{'hover':showStatus === 0}">
            <input type="button"
                   value="常用公式"
                   class="gs_an"
                   style=" background:none; border:0px; cursor:pointer"
                   @click="setTab(0)">
          </li>
          <li id="twoo2"
              :class="{'hover':showStatus === 1}">
            <input type="button"
                   value="符号"
                   style=" background:none; border:0px; cursor:pointer"
                   @click="setTab(1)">
          </li>
          <li id="twoo3"
              :class="{'hover':showStatus === 2}">
            <input type="button"
                   value="希腊字母"
                   style=" background:none; border:0px; cursor:pointer"
                   @click="setTab(2)">
          </li>
        </ul>
      </div>
      <div id="div_FormulaBlock"
           class="menuDiv">
        <div id="con_twoo_1"
             v-if="showStatus === 0">
          <div class="gs_nr">
            <ul>
              <li class="fc1">
                <a @click="insertWrite('\\frac', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc2">
                <a @click="insertWrite('^{}/_{}', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc3">
                <a @click="insertWrite('x^', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc4">
                <a @click="insertWrite('x_', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc5">
                <a @click="insertWrite('x_{}^{}', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc6">
                <a @click="insertWrite('\\bar{x}', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc7">
                <a @click="insertWrite('\\sqrt', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc8">
                <a @click="insertWrite('\\nthroot3{}', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc9">
                <a @click="insertWrite('\\nthroot', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc10">
                <a @click="insertWrite('\\sum^{}_{n=}', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <!-- <li class="fc11">
                 <a @click="insertWrite('\\sum', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>-->
              <li class="fc12">
                <a @click="insertWrite('\\log_{}\\left(\\right)', true)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fc13">
                <a @click="insertWrite('\\ln', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <!-- <li class="fc14">
                 <a @click="insertWrite('\\int_{}^{}', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>-->
              <!-- <li class="fc15">
                <a
                  @click="insertWrite('\\oint_{}^{}', false)"
                  href="javascript:void(0);"
                >&nbsp;</a>
              </li> -->
            </ul>
          </div>
        </div>
        <div id="con_twoo_2"
             v-else-if="showStatus === 1">
          <div class="gs_nr">
            <ul>
              <li class="fa1">
                <a @click="insertWrite('+', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa2">
                <a @click="insertWrite('-', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa3">
                <a @click="insertWrite('\\pm', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa4">
                <a @click="insertWrite('\\times', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa5">
                <a @click="insertWrite('\\ast', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa6">
                <a @click="insertWrite('\\div', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa7">
                <a @click="insertWrite('/', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa8">
                <a @click="insertWrite('\\infty', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa9">
                <a @click="insertWrite('\\partial', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa10">
                <a @click="insertWrite('\\bigtriangleup', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa11">
                <a @click="insertWrite('=', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa12">
                <a @click="insertWrite('\\ne', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa13">
                <a @click="insertWrite('\\approx', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa14">
                <a @click="insertWrite('>', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa15">
                <a @click="insertWrite('<', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa16">
                <a @click="insertWrite('\\ge', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa17">
                <a @click="insertWrite('\\le', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa18">
                <a @click="insertWrite('\\Pi', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa19">
                <a @click="insertWrite('\\int', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <!--<li class="fa20">
                <a @click="insertWrite('\\cap', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa21">
                <a @click="insertWrite('\\cup', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>-->
              <!-- <li class="fa22">
                 <a @click="insertWrite('\\because', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa23">
                 <a @click="insertWrite('\\therefore', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa24">
                 <a @click="insertWrite('\\subset', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa25">
                 <a @click="insertWrite('\\supset', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa26">
                 <a @click="insertWrite('\\subseteq', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa27">
                 <a @click="insertWrite('\\supseteq', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa28">
                 <a @click="insertWrite('\\nsubseteq', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa29">
                 <a @click="insertWrite('\\nsupseteq', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa30">
                 <a @click="insertWrite('\\in', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa31">
                 <a @click="insertWrite('\\ni', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>
               <li class="fa32">
                 <a @click="insertWrite('\\notin', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>-->

              <!-- <li class="fa33">
                <a @click="insertWrite('\\mapsto', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa34">
                <a @click="insertWrite('\\leftarrow', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>-->
              <li class="fa35">
                <a @click="insertWrite('\\rightarrow', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <!--<li class="fa36">
                <a @click="insertWrite('\\Leftarrow', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa37">
                <a @click="insertWrite('\\Rightarrow', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa38">
                <a @click="insertWrite('\\leftrightarrow', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fa39">
                <a @click="insertWrite('\\Leftrightarrow', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>-->
            </ul>
          </div>
        </div>
        <div id="con_twoo_3"
             v-else-if="showStatus === 2">
          <div class="gs_nr">
            <ul>
              <li class="fb1">
                <a @click="insertWrite('\\alpha', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb2">
                <a @click="insertWrite('\\beta', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb3">
                <a @click="insertWrite('\\gamma', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb4">
                <a @click="insertWrite('\\delta', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb5">
                <a @click="insertWrite('\\varepsilon', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb6">
                <a @click="insertWrite('\\varphi', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb7">
                <a @click="insertWrite('\\lambda', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb8">
                <a @click="insertWrite('\\mu', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb9">
                <a @click="insertWrite('\\rho', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb10">
                <a @click="insertWrite('\\sigma', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb11">
                <a @click="insertWrite('\\omega', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb12">
                <a @click="insertWrite('\\Gamma', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <!--   <li class="fb13">
                   <a @click="insertWrite('\\Delta', false)"
                      href="javascript:void(0);">&nbsp;</a>
                 </li>
                 <li class="fb14">
                   <a @click="insertWrite('\\Theta', false)"
                      href="javascript:void(0);">&nbsp;</a>
                 </li>
                 <li class="fb15">
                   <a @click="insertWrite('\\Lambda', false)"
                      href="javascript:void(0);">&nbsp;</a>
                 </li>
                 <li class="fb16">
                   <a @click="insertWrite('\\Xi', false)"
                      href="javascript:void(0);">&nbsp;</a>
                 </li>-->
              <!-- <li class="fb17">
                 <a @click="insertWrite('\\Pi', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>-->
              <li class="fb18">
                <a @click="insertWrite('\\Sigma', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <!-- <li class="fb19">
                 <a @click="insertWrite('\\Upsilon', false)"
                    href="javascript:void(0);">&nbsp;</a>
               </li>-->
              <li class="fb20">
                <a @click="insertWrite('\\Phi', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <!--<li class="fb21">
                <a @click="insertWrite('\\Psi', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb22">
                <a @click="insertWrite('\\Omega', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>-->
              <li class="fb23">
                <a @click="insertWrite('\\Xi', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
              <li class="fb24">
                <a @click="insertWrite('\\Theta', false)"
                   href="javascript:void(0);">&nbsp;</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'formula',
    props: {
      visible: { type: Boolean, default: true },
      toggleFn: { type: Function, default: () => null },
    },
    data() {
      return {
        showStatus: 1,
      }
    },
    methods: {
      insertWrite(type, bool) {
        this.$emit('toggleFn', type, bool)
      },
      setTab(type) {
        this.showStatus = type
      },
      closeDialog() {
        this.$emit('update:visible', false)
      },
    },
  }
</script>
<style lang="scss" scoped>
  $bgUrl: '~@/assets/images/formula/';
  .formula {
    .gs {
      width: 328px;
      position: absolute;
      top: 25px;
      left: 62px;
      z-index: 1;

      .carts {
        width: 328px;
        height: 8px;
        background: url($bgUrl + 'jt.png') no-repeat center top;
        display: block;
      }
    }

    .gs_tit {
      width: 328px;
      background: url($bgUrl + 'gs_tit.gif') repeat-x;
      height: 29px;
      border-left: 1px solid #c1cee3;
      border-right: 1px solid #c1cee3;

      ul {
        padding-top: 7px;
        overflow: hidden;

        li {
          float: left;
          margin-left: 12px;
          display: inline-block;
          font-size: 14px !important;
          font-weight: bold;
          cursor: pointer;
          line-height: 24px;
          height: 24px;
          width: 93px;
          background: url($bgUrl + 'bg-menu-tab.gif') no-repeat 0 0;
          text-align: center;

          input {
            height: 24px;
            width: 93px;
            display: block;
            outline: none;
          }

          &.hover {
            background: url($bgUrl + 'bg-menu-tab.gif') no-repeat 0 -24px;
          }
        }
      }
    }

    .gs_nr {
      border: 1px solid #c1cee3;
      border-top: none;
      background: #fff;
      overflow: hidden;
      width: 328px;
      padding: 10px 0 10px 10px;
    }

    .gs_nr li {
      margin: 0 6px 6px 0;
      float: left;
      width: 30px;
      height: 30px;
      background: url($bgUrl + 'function.gif') no-repeat;
      cursor: pointer;
      text-indent: -9999px;
    }

    .gs_nr li a {
      display: block;
      height: 30px;
      text-decoration: none;
      width: 30px;
      outline: medium none;
    }

    .gs_nr li.fa1 {
      background-position: 0px 0px;
    }

    .gs_nr li.fa2 {
      background-position: -34px 0px;
    }

    .gs_nr li.fa3 {
      background-position: -68px 0px;
    }

    .gs_nr li.fa4 {
      background-position: -102px 0px;
    }

    .gs_nr li.fa5 {
      background-position: -136px 0px;
    }

    .gs_nr li.fa6 {
      background-position: -170px 0px;
    }

    .gs_nr li.fa7 {
      background-position: -204px 0px;
    }

    .gs_nr li.fa8 {
      background-position: -238px 0px;
    }

    .gs_nr li.fa9 {
      background-position: -272px 0px;
    }

    .gs_nr li.fa10 {
      background-position: 0px -34px;
    }

    .gs_nr li.fa11 {
      background-position: -34px -34px;
    }

    .gs_nr li.fa12 {
      background-position: -68px -34px;
    }

    .gs_nr li.fa13 {
      background-position: -102px -34px;
    }

    .gs_nr li.fa14 {
      background-position: -136px -34px;
    }

    .gs_nr li.fa15 {
      background-position: -170px -34px;
    }

    .gs_nr li.fa16 {
      background-position: -204px -34px;
    }

    .gs_nr li.fa17 {
      background-position: -238px -34px;
    }

    .gs_nr li.fa18 {
      background: url($bgUrl + 'form2.gif') no-repeat;
      background-position: -272px -34px;
      border: 1px #dddddd solid;
    }

    .gs_nr li.fa19 {
      background: url($bgUrl + 'form2.gif') no-repeat;
      background-position: -306px 0px;
      border: 1px #dddddd solid;
    }

    .gs_nr li.fa20 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: 0px -68px;;
    }

    .gs_nr li.fa21 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -34px -68px;
    }

    .gs_nr li.fa22 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -68px -68px;
    }

    .gs_nr li.fa23 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -102px -68px;
    }

    .gs_nr li.fa24 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -136px -68px;
    }

    .gs_nr li.fa25 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -170px -68px;
    }

    .gs_nr li.fa26 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -204px -68px;
    }

    .gs_nr li.fa27 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -238px -68px;
    }

    .gs_nr li.fa28 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: 0px -102px;
    }

    .gs_nr li.fa29 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -34px -102px;
    }

    .gs_nr li.fa30 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -68px -102px;
    }

    .gs_nr li.fa31 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -102px -102px;
    }

    .gs_nr li.fa32 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -136px -102px;
    }

    .gs_nr li.fa33 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -170px -102px;
    }

    .gs_nr li.fa34 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -204px -102px;
    }

    .gs_nr li.fa35 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -240px -102px;
    }

    .gs_nr li.fa36 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: 0px -136px;
    }

    .gs_nr li.fa37 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -34px -136px;
    }

    .gs_nr li.fa38 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -68px -136px;
    }

    .gs_nr li.fa39 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -102px -136px;
    }

    .gs_nr li.fa17 {
      background-position: -238px -34px;
    }

    .gs_nr li.fa17 {
      background-position: -238px -34px;
    }

    .gs_nr li.fb1 {
      background-position: 0px -68px;
    }

    .gs_nr li.fb2 {
      background-position: -34px -68px;
    }

    .gs_nr li.fb3 {
      background-position: -68px -68px;
    }

    .gs_nr li.fb4 {
      background-position: -102px -68px;
    }

    .gs_nr li.fb5 {
      background-position: -136px -68px;
    }

    .gs_nr li.fb6 {
      background-position: -170px -68px;
    }

    .gs_nr li.fb7 {
      background-position: -204px -68px;
    }

    .gs_nr li.fb8 {
      background-position: -238px -68px;
    }

    .gs_nr li.fb9 {
      background-position: -272px -68px;
    }

    .gs_nr li.fb10 {
      background-position: 0px -102px;
    }

    .gs_nr li.fb11 {
      background-position: -34px -102px;
    }

    .gs_nr li.fb12 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -102px -204px;
    }

    .gs_nr li.fb13 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -136px -204px;
    }

    .gs_nr li.fb14 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -170px -204px;
    }

    .gs_nr li.fb15 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -204px -204px;
    }

    .gs_nr li.fb16 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -238px -204px;
    }

    .gs_nr li.fb17 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -0px -238px;
    }

    .gs_nr li.fb18 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -34px -238px;
    }

    .gs_nr li.fb19 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -68px -238px;
    }

    .gs_nr li.fb20 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -102px -238px;
    }

    .gs_nr li.fb21 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -136px -238px;
    }

    .gs_nr li.fb22 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -170px -238px;
    }

    .gs_nr li.fb23 {
      background: url($bgUrl + 'form2.gif') no-repeat;
      background-position: -68px -102px;
      border: 1px #dddddd solid;
    }

    .gs_nr li.fb24 {
      background: url($bgUrl + 'form2.gif') no-repeat;
      background-position: -102px -102px;
      border: 1px #dddddd solid;
    }

    .gs_nr li.fc1 {
      background-position: 0px -136px;
    }

    .gs_nr li.fc2 {
      background-position: -34px -136px;
    }

    .gs_nr li.fc3 {
      background-position: -68px -136px;
    }

    .gs_nr li.fc4 {
      background-position: -102px -136px;
    }

    .gs_nr li.fc5 {
      background-position: -136px -136px;
    }

    .gs_nr li.fc6 {
      background-position: -170px -136px;
    }

    .gs_nr li.fc7 {
      background-position: -204px -136px;
    }

    .gs_nr li.fc8 {
      background-position: -238px -136px;
    }

    .gs_nr li.fc9 {
      background-position: -272px -136px;
    }

    .gs_nr li.fc10 {
      background-position: 0px -170px;
    }

    .gs_nr li.fc11 {
      background-position: -34px -170px;
    }

    .gs_nr li.fc12 {
      background-position: -68px -170px;
    }

    .gs_nr li.fc13 {
      background-position: -102px -170px;
    }

    .gs_nr li.fc14 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -136px -306px;
    }

    .gs_nr li.fc15 {
      background: url($bgUrl + 'form1.png') no-repeat;
      background-position: -170px -306px;
    }

    .gs_tit .gs_an {
      background: none;
    }
  }
</style>
